<template>
  <form
    ref="formEl"
    method="GET"
    class="d-flex align-items-center search-box"
    @submit.prevent="search"
  >
    <i class="fa fa-search" aria-hidden="true"></i>
    <input
      v-model="query"
      type="text"
      class="form-control"
      placeholder="Search"
      required
    />
  </form>
</template>

<script setup lang="ts">
import { ref } from "vue";

const formEl = ref<HTMLFormElement>();
const query = ref<string>(extractSearchQuery() ?? "");

function search() {
  const path = location.pathname.replace(/(tag|search|page).*/, "");
  document.location = path + "search/" + encodeURIComponent(query.value);
}

function extractSearchQuery() {
  const match = location.pathname.match(/\/search\/([^/]+)\/?/);
  return match ? decodeURIComponent(match[1]) : null;
}
</script>
